export default "__VITE_ASSET__af4185f8__"